var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{attrs:{"dense":"","outlined":"","color":_vm.color,"icon":_vm.icon,"border":"left"}},[_vm._v(" "+_vm._s(_vm.message)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }